import React from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { ActiveLabel, TrashIconWrapper, SportLabel, CheckboxWrapper, SportSlug, SportLabelWrapper } from 'src/main/cms/Sports/SportsList/SingleSport.style';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { SingleSportState, SingleSportType } from 'src/main/cms/Sports/SportsList/SingleSportState.state';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem } from 'src/domains/layouts/shared/cms/list/List.style';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';

export const SingleSport = observer((propsInner: SingleSportType) => {
    const props = useAsObservableSource(propsInner);
    const { sport_label, sport_slug, is_active_header_image, is_active, sport_type } = props.sportData;
    const { onChangeActiveSport } = props.sportState;
    const [state] = React.useState(() => new SingleSportState(props));

    return (
        <ListItem direction='row' data-test={`customize-sport-${sport_label}`}>
            <SportLabelWrapper>
                <SportSlug data-test='customize-sport-slug'>{sport_slug}</SportSlug>
                <SportLabel data-test='customize-sport-label'>{sport_label}</SportLabel>
            </SportLabelWrapper>

            <CheckboxWrapper>
                <Checkbox labelSide='right' onChange={(): Promise<void> => onChangeActiveSport(is_active, propsInner.sportData)} isChecked={is_active} isDisabled={false} dataTest='customize-sport-is-active-checkbox'>
                    <ActiveLabel>Is Sport Active</ActiveLabel>
                </Checkbox>
                <Checkbox labelSide='right' onChange={(): Promise<void> => state.setActiveBgImg('header')} isChecked={is_active_header_image} isDisabled={sport_type === 'new-sport'} dataTest='customize-sport-header-checkbox'>
                    <ActiveLabel>Show header image</ActiveLabel>
                </Checkbox>
            </CheckboxWrapper>

            <ButtonsWrapper>
                <Button version='secondary' size='small' onClick={state.onEdit} dataTest='customize-sport-edit'>Edit</Button>
                <TrashIconWrapper onClick={state.onDelete} />
            </ButtonsWrapper>
        </ListItem>
    );
});
